<template>
  <div>
    <div class="mb-3">
      <vs-input :label="$t('subject')" :placeholder="$t('subject')" v-model="messageTemplateFormData.title" class="w-full"/>
      <validation-error :model-error="messageTemplateFormErrors.title"></validation-error>
    </div>

    <div class="mb-3">
      <label class="vs-input--label" v-text="$t('category')"></label>
<!--      <v-select :options="categories" :reduce="label => label.value" :placeholder="$t('category')" v-model="messageTemplateFormData.message_category_id" class="md:mb-0" />-->
      <select v-model="messageTemplateFormData.message_category_id" class="vs-inputx vs-input--input normal md:mb-0">
        <option value="">{{ $t('category') }}</option>
        <option v-for="(option, key) in categories" :key="'category_' + key" :value="option.value">{{ option.label }}</option>
      </select>
      <validation-error :model-error="messageTemplateFormErrors.message_category_id"></validation-error>
    </div>

    <div class="mb-3">
      <label class="vs-input--label" v-text="$t('content')"></label>
      <vs-textarea class="mb-0" v-model="messageTemplateFormData.content" :placeholder="$t('content')" />
      <validation-error :model-error="messageTemplateFormErrors.content"></validation-error>
    </div>

    <div>
      <label>Bytes:</label> <span v-text="messageTemplateFormData.bytes"></span>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Template from '@/models/Template'

export default {
  name: 'Shared.Messages.Templates.Edit',
  data () {
    return {
      messageTemplateFormErrors: {},
      messageTemplateFormData: {}
    }
  },
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  watch: {
    'messageTemplateFormData.content' (val) {
      this.messageTemplateFormData.bytes = this.$stringHelper.getContentLength(val)
    }
  },
  mounted () {
    this.initMessageTemplateFormData()
    EventBus.$on('editMessageTemplate', this.edit)
    EventBus.$on('updateMessageTemplate', this.update)
    EventBus.$on('initMessageTemplateFormData', this.initMessageTemplateFormData)
  },
  methods: {
    async edit (data) {
      this.messageTemplateFormData = data
    },
    async update () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editTemplateButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await Template.update(this.messageTemplateFormData)

          this.$store.dispatch('setIsFormInProgress', false)

          this.$emit('updateMessageTemplateSuccess')

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.messageTemplateFormErrors = {}
          this.initMessageTemplateFormData()
        }
      } catch (e) {
        this.messageTemplateFormErrors = e.response.data.errors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editTemplateButton > .con-vs-loading')
    },
    initMessageTemplateFormData () {
      this.messageTemplateFormData = {
        title: '',
        content: '',
        message_category_id: '',
        bytes: 0
      }
    }
  }
}
</script>

<style lang="scss">
  #editTemplateButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>

